import { useEffect, useState } from "react";
import ContactForm from "../layouts/ContactForm";
import { Link } from 'react-router-dom'


const slides = [
    { id: 1, text: "From concept to execution, we help businesses uncover innovative opportunities and drive seamless implementation for long-term success.", title: "Strategic Consulting & Design", src: "assets/Strategy_Consulting.png" },
    { id: 2, text: "Optimize cloud spending with detailed analysis, identifying underutilized resources, rightsizing instances, and implementing cost-saving strategies to maximize efficiency.", title: "FinOps", src: "assets/Technology_POC-s.png" },
    { id: 3, text: "Boost business agility through automation, streamlining tasks such as resource provisioning, application deployment, and infrastructure scaling for a more efficient workflow.", title: "Change Management", src: "assets/Strategic_Roadmapping.png" }
];

const slides1 = [
    { id: 1, text: "Ensure seamless performance with end-to-end support, quality metrics, and service-level agreements—enhancing efficiency, reducing costs, and enabling strategic growth.", title: "Application & Product Maintenance Services", src: "assets/Application___Product_Maintenance.png" },
    { id: 2, text: "Optimize cloud performance, security, and scalability with proactive monitoring, automation, and cost-efficient management solutions.", title: "CloudOps", src: "assets/AI-enabled_Quality_Assurance_as_a_Service.png" }
];

const Home = () => {

    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    /* sliders start*/
    const [currentIndex, setCurrentIndex] = useState(0);
    const visibleSlides = 1; // Number of slides to display at a time

    const nextSlide = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex + 1 >= slides.length - (visibleSlides - 1) ? 0 : prevIndex + 1
        );
    };

    const prevSlide = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex - 1 < 0 ? slides.length - visibleSlides : prevIndex - 1
        );
    };

    /* sliders end*/

    /* slider1 start*/
    const [currentIndex1, setCurrentIndex1] = useState(0);
    const visibleSlides1 = 1; // Number of slides to display at a time

    const nextSlide1 = () => {
        setCurrentIndex1((prevIndex) =>
            prevIndex + 1 >= slides1.length - (visibleSlides1 - 1) ? 0 : prevIndex + 1
        );
    };

    const prevSlide1 = () => {
        setCurrentIndex1((prevIndex) =>
            prevIndex - 1 < 0 ? slides1.length - visibleSlides1 : prevIndex - 1    
        );
    };

    /* slider1 end*/



    useEffect(() => {
        window.scrollTo(0, 0);

        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    return (
        <div className="home-hero">
            <div className="hero-content">
                <div className="home-hero-ribbon d-flex align-items-center justify-content-center">
                    <p className="text-white mb-0">shanvatech Expands Enterprise Business Capabilities through a Strategic Acquisition from DMI &nbsp;&nbsp;&nbsp;</p>
                    <button style={{ borderRadius: "10px", padding: "10px 30px 10px 30px", fontSize: "20px" }}>READ MORE</button>
                </div>
                {/* <video className="w-100" autoplay muted>
                    <source src="/assets/Home-Hero-Video.mp4" type="video/mp4"/>
                    Your browser does not support the video tag.
                </video> */}


                <div className="videoContent">
                    <video autoPlay loop muted playsInline style={{ width: "100%", height: "700px", objectFit: "cover" }}>
                        <source src="/assets/Home-Hero-Video.mp4" type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>

                <div className="header">
                    <h2>Build Your Future with Shanvatech</h2>
                    <h1 style={{ paddingBottom:"50px" }}>Your Trusted Partner in Digital Innovation</h1>
                    <button style={{ borderRadius: "10px", padding: '10px 30px 10px 30px', fontSize: '20px' }}>PARTNER WITH SHANVATECH <i class="fas fa-arrow-right"></i></button>
                </div>


            </div>
            <div className="container-fluid"
                style={{ backgroundImage: "linear-gradient(25deg, #d6c2f0 0%, rgb(255, 255, 255) 70%)", paddingTop: "100px" }}>
                <h1>Facts About <strong>Shanvatech</strong></h1>
                <p>Shanvatech is a dynamic technology solutions provider, specializing in IT services, infrastructure, and end-to-end hiring solutions for businesses of all sizes.</p>
                <div className="row">
                    <div className="col">
                        <div className="card about-Shanva">
                            <div className="card-body">
                                <h5 className="card-title">Trusted Technology & Hiring Partner</h5>
                                <p className="card-text">Shanvatech accelerates digital transformation and workforce optimization, delivering scalable solutions that drive efficiency and business growth for enterprises worldwide
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card about-Shanva">
                            <div className="card-body">
                                <h5 className="card-title">Expanding Global Presence</h5>
                                <p className="card-text">, with expertise spanning India &  Singapore</p>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card about-Shanva">
                            <div className="card-body">
                                <h5 className="card-title">Comprehensive IT & Staffing Solutions</h5>
                                <p className="card-text">from software services to strategic talent acquisition</p>

                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card about-Shanva">

                            <div className="card-body">
                                <h5 className="card-title">Recognized for Rapid Growth</h5>
                                <p className="card-text">in IT, infrastructure, and workforce solutions </p>

                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card about-Shanva">

                            <div className="card-body">
                                <h5 className="card-title">People-Centric Approach</h5>
                                <p className="card-text">fostering a collaborative and innovative work environment </p>

                            </div>
                        </div>
                    </div>

                </div>
            </div>

            {/* <div class="container-fluid" style={{paddingTop: "100px"}}>
        <h1>Delivering Globally with <strong>Speed and Scale</strong></h1>
        <p>Shanvatech’s unique global delivery footprint enables it to provide Speed of Collaboration to clients
            anywhere in the world through Nearshore delivery centers in Latin America, Eastern Europe, and Southeast
            Asia. In addition, Shanvatech’s deep technical capabilities in India deliver Expertise at Scale for industry
            leaders and digital natives.</p>
        <div class="row">
            <div class="col-md-3">
                <div class="">
                    
                    <div class="card-body no-borders">
                        <h2>Speed of Collaboration through <strong>Global Nearshore Support</strong></h2>
                       
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card">
                    
                    <div class="card-body america">
                        <h2 class="card-title">America</h2>
                        <p class="card-text">3,800+ people in 7
                            countries across LatAm</p>
                        <a href="#">LEARN MORE</a>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card">
                    <div class="card-body Singapore">
                        <h2 class="card-title">Singapore</h2>
                        <p class="card-text">Nearly 500 people in
                            Eastern Europe</p>
                        <a href="#">LEARN MORE</a>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card">
                    <div class="card-body UAE">
                        <h2 class="card-title">UAE</h2>
                        <p class="card-text">Approximately 600
                            people in Southeast
                            Asia</p>
                        <a href="#">LEARN MORE</a>
                    </div>
                </div>
            </div>
        </div>
    </div> */}

            {/* <div class="container-fluid">

        <div class="row">
            <div class="col-md-3">
                <div class="">
                    <div class="card-body no-borders">
                        <h2><strong>Expertise at Scale</strong> from India</h2>
                        
                    </div>
                </div>
            </div>
            <div class="col-md-9">
                <div class="card">
                    <div class="card-body india">
                        <h2 class="card-title">India</h2>
                        <p class="card-text">4,700+ engineers, designers, SMEs, and technical experts on pace to double
                            (2x) India operations in the next 3 years</p>
                        <a href="#">LEARN MORE</a>
                    </div>
                </div>
            </div>


        </div>
    </div> */}

            <div class="container-fluid" style={{ paddingTop: "100px" }}>
                <h1>Integrated <strong>Service Offerings</strong></h1>
                <p>Strategic, Digital Engineering, and Managed Services to address every client need, bolstered by Practices and
                    expert practitioners with command over new and emerging technologies.</p>
                <h3>Strategic Services</h3>
                <p>Shanvatech’s Innovation Experts guide clients through critical digital engineering decisions, weighing
                    emerging perspectives on the evolution of cloud, data, AI, and the broader digital engineering landscape.
                </p>
                {/* <div class="row">

            
            <div class="content">
                <img src="assets/Strategy_Consulting.png" alt="Image 1"/>
                <h3 class="card-title">Staffing Solutions</h3>
               
              </div>
            
              <div class="content">
                <img src="assets/Technology_POC-s.png" alt="Image 2"/>
                <h3>Content 2</h3>
              </div>
            
              <div class="content">
                <img src="assets/Strategic_Roadmapping.png" alt="Image 3"/>
                <h3>Content 3</h3>
              </div>
            
              <div class="content">
                <img src="assets/Technology_Consulting_Services.png" alt="Image 4"/>
                <h3>Content 4</h3>
              </div>
        </div> */}

                {isMobile ?
                    <>
                        {/* ------------for mobile view------------- */}


                        <div className="row no-gutters shanvatech-row mobileView">
                            {slides.slice(currentIndex, currentIndex + visibleSlides).map((slide) => (
                                <div className="col shanvatech"
                                    style={{
                                        backgroundImage: `url(${slide.src})`,
                                        backgroundSize: "cover"
                                    }}>
                                    <div className="overlay-content">
                                        <h4>{slide.title}</h4>
                                        <p>{slide.text}</p>
                                        <Link to="/services">
                                            <button type="button" className="btn btn-primary OurService-knowMore">LEARN MORE</button>
                                        </Link>
                                    </div>
                                </div>

                            ))}


                            {/* <div className="col shanvatech OurImageNew4">
                    <div className="overlay-content">
                        <h4>Workforce & Operations Outsourcing</h4>
                        <p>4,700+ engineers, designers, SMEs, and technical experts on pace to double
                            (2x) India operations in the next 3 years</p>
                            {/* <a href="/it-service">
                                <button type="button" class="btn btn-primary OurService-knowMore">LEARN MORE</button>
                            </a> 
                        </div>
                    </div> */}
                        </div>
                        <div className="d-flex justify-content-end mt-3 pr-4">
                            <button style={{ backgroundColor: "white", border: "1px solid" }} className="btn btn-default mr-2" onClick={prevSlide}>
                                <i class="fas fa-arrow-left"></i>
                            </button>
                            <button style={{ backgroundColor: "white", border: "1px solid" }} className="btn btn-default" onClick={nextSlide}>
                                <i class="fas fa-arrow-right"></i>
                            </button>
                        </div>

                        {/* ------------for mobile view end------------- */}
                    </> :
                    <>
                        <div className="row no-gutters shanvatech-row">
                            <div className="col shanvatech OurImageNew1">
                                <div className="overlay-content">
                                    <h4>Strategic Consulting & Design</h4>
                                    <p>From concept to execution, we help businesses uncover innovative opportunities and drive seamless implementation for long-term success.</p>
                                    <Link to="/services">
                                        <button type="button" className="btn btn-primary OurService-knowMore">LEARN MORE</button>
                                    </Link>
                                </div>
                            </div>
                            <div className="col shanvatech OurImageNew2">
                                <div className="overlay-content">
                                    <h4>Technology Consulting Services</h4>
                                    <p>Design, implement, and maximize the value of innovative technology solutions.</p>
                                    <Link to="/Technology-Consulting-Services">
                                        <button type="button" class="btn btn-primary OurService-knowMore">LEARN MORE</button>
                                    </Link>
                                </div>
                            </div>
                            <div className="col shanvatech OurImageNew3">
                                <div className="overlay-content">
                                    <h4>Workforce Strategy & plans</h4>
                                    <p>Align talent acquisition with business goals through strategic workforce planning, ensuring agility, efficiency, and long-term success.</p>
                                    <Link to="/workforce-strategy-and-plans">
                                        <button type="button" class="btn btn-primary OurService-knowMore">LEARN MORE</button>
                                    </Link>
                                </div>
                            </div>
                            {/* <div className="col shanvatech OurImageNew4">
                    <div className="overlay-content">
                        <h4>Workforce & Operations Outsourcing</h4>
                        <p>4,700+ engineers, designers, SMEs, and technical experts on pace to double
                            (2x) India operations in the next 3 years</p>
                            {/* <a href="/it-service">
                                <button type="button" class="btn btn-primary OurService-knowMore">LEARN MORE</button>
                            </a> 
                        </div>
                    </div> */}
                        </div>
                    </>}








            </div>

            {/* <div class="container-fluid">
        <h3>Digital Engineering Services</h3>
        <p>Shanvatech digital engineering services leverage our deep domain expertise to deliver production-grade
            engineering at scale and speed through agile frameworks, AI and automation toolsets, and mature processes
            for ensuring velocity, quality, and efficiency of transformation for clients. Our outcome-based engineering
            delivery helps enterprises leverage cloud, data, and AI to transform their technology stack, operations, and
            culture for the future, reduce technology debt, and deliver superior experiences for their end-customers.
        </p>


    </div> */}




            <div className="container-fluid">
                <h1>Managed Services</h1>
                <p>Enhance operational efficiency and accountability with Shanvatech’s managed services, providing specialized expertise and resources to support your business needs seamlessly.
                </p>


               

                {isMobile ? 
                <>
                <div className="row no-gutters shanvatech-row">
                {slides1.slice(currentIndex1, currentIndex1 + visibleSlides1).map((slide) => (
                    <div className="col shanvatech "
                    style={{
                        backgroundImage: `url(${slide.src})`,
                        backgroundSize: "cover"
                    }}>
                    
                        <div className="overlay-content">
                            <h4>{slide.title}</h4>
                            <p>{slide.text}</p>
                            <Link to="/Application-and-product-maintanence">
                                <button type="button" className="btn btn-primary OurService-knowMore">LEARN MORE</button>
                            </Link>
                        </div>
                    </div>
                ))}
                </div>
                <div className="d-flex justify-content-end mt-3 pr-4">
                <button style={{ backgroundColor: "white", border: "1px solid" }} className="btn btn-default mr-2" onClick={prevSlide1}>
                    <i class="fas fa-arrow-left"></i>
                </button>
                <button style={{ backgroundColor: "white", border: "1px solid" }} className="btn btn-default" onClick={nextSlide1}>
                    <i class="fas fa-arrow-right"></i>
                </button>
            </div>
                </>
                

                :
                 <div className="row no-gutters shanvatech-row">
                 <div className="col shanvatech OurImage1">
                     <div className="overlay-content">
                         <h4>Application & Product Management</h4>
                         <p>4,700+ engineers, designers, SMEs, and technical experts on pace to double
                             (2x) India operations in the next 3 years</p>
                         <Link to="/Application-and-product-maintanence">
                             <button type="button" className="btn btn-primary OurService-knowMore">LEARN MORE</button>
                         </Link>
                     </div>
                 </div>
                 <div className="col shanvatech OurImage2">
                     <div className="overlay-content">
                         <h4>CloudOps</h4>
                         <p>4,700+ engineers, designers, SMEs, and technical experts on pace to double
                             (2x) India operations in the next 3 years</p>
                         <Link to="/CloudOps">
                             <button type="button" className="btn btn-primary OurService-knowMore">LEARN MORE</button>
                         </Link>
                     </div>
                 </div>
             </div>
            }

                {/* <div className="row no-gutters shanvatech-row">
                {slides1.slice(currentIndex1, currentIndex1 + visibleSlides1).map((slide) => (
                    <div className="col shanvatech OurImage1">
                        <div className="overlay-content">
                            <h4>{slide.title}</h4>
                            <p>{slide.text}</p>
                            <Link to="/Application-and-product-maintanence">
                                <button type="button" className="btn btn-primary OurService-knowMore">LEARN MORE</button>
                            </Link>
                        </div>
                    </div>
                ))}
                    
                </div> */}


            </div>

            {/* <div class="container-fluid">
        <h1><strong>Focus</strong> Industries</h1>
        <p>A trusted partner for industry leaders and digital natives across every major sector of the global economy.
        </p>

        <div class="row">

            <div class="col-md-3">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-2">
                               <i class="fas fa-cogs"></i>
                            </div>
                            <div class="col-sm-10">
                                <h5 class="card-title">Banking , Financial services & Insurance(BFSI)</h5>

                                <a href="#">LEARN MORE</a>
                            </div>
                        </div>
                    </div>
                    
                   
                </div>
            </div>
            <div class="col-md-3">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-2">
                                <i class="fas fa-heart"></i>
                            </div>
                            <div class="col-sm-10">
                                <h5 class="card-title">Health Care & Life Sciences</h5>

                                <a href="#">LEARN MORE</a>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-2">
                                <i class="fas fa-check"></i>
                            </div>
                            <div class="col-sm-10">
                                <h5 class="card-title">Retail & E-commerce</h5>

                        <a href="#">LEARN MORE</a>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-2">
                                <i class="fas fa-exclamation-circle"></i>
                            </div>
                            <div class="col-sm-10">
                                <h5 class="card-title">Manufactureing & Supplychain</h5>

                                <a href="#">LEARN MORE</a>
                            </div>
                        </div>
                       
                    </div>
                </div>
            </div>

        </div>


        <div style={{paddingTop:"50px;"}} class="row">

            <div class="col-md-3">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-2">
                                <i class="fas fa-envelope"></i>
                            </div>
                            <div class="col-sm-10">
                                <h5 class="card-title">Telecommunication & Media</h5>

                        <a href="#">LEARN MORE</a>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-2">
                                <i class="fas fa-phone-alt"></i>
                            </div>
                            <div class="col-sm-10">
                                <h5 class="card-title">Education & E-learning</h5>

                        <a href="#">LEARN MORE</a>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-2">
                                <i class="fas fa-phone-alt"></i>
                            </div>
                            <div class="col-sm-10">
                                <h5 class="card-title">Energy & Utilities</h5>

                        <a href="#">LEARN MORE</a>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-2">
                                <i class="fas fa-phone-alt"></i>
                            </div>
                            <div class="col-sm-10">
                                <h5 class="card-title">Government & Public Sectors</h5>

                                <a href="#">LEARN MORE</a>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>

        </div>
    </div> */}







            {/*  <div class="container-fluid">

        <p>Trusted by.</p>

        <div class="row">

            <div class="col-md-6">
                <h2>brands</h2>
            </div>

        </div>
    </div> */}

            {/* <div class="container-fluid">

        <div class="row client-Stories">

            <div class="col-md-3">
                <div class="">
                    <div class="card-body">
                        <h5 class="card-title">Client Success Stories</h5>
                        <p class="card-text">Shanvatech applies industry expertise and digital engineering discipline to
                            accelerate business outcomes for industry leaders and digital natives.</p>
                        <a  href="#" class="btn btn-primary More-success-Stories">MORE SUCCESS STORIES</a>
                    </div>
                </div>
            </div>
            <div class="col-md-3 client-stories-card">
                <div class="card story-image1">
                    {/* <img class="card-img-top" src="assets/movoto-background.png" alt="Card image cap"/>
                    <div class="card-body" style={{paddingTop:"200px"}}>
                        <h4 style={{color:"white"}}class="card-title">India</h4>
                        
                        <a href="#" >LEARN MORE</a>
                    </div>
                </div>
            </div>
            <div class="col-md-3 client-stories-card">
                <div class="card story-image2">
                    {/* <img class="card-img-top" src="assets/Sagent_background.png" alt="Card image cap"/> 
                    <div class="card-body" style={{paddingTop:"200px"}}>
                    <h4 style={{color:"white"}}class="card-title">India</h4>
                        
                        <a href="#" >LEARN MORE</a>
                    </div>
                </div>
            </div>
            <div class="col-md-3 client-stories-card">
                <div class="card story-image3">
                    {/* <img class="card-img-top" src="assets/Switchfly_Background.png" alt="Card image cap"/>
                    <div class="card-body" style={{paddingTop:"200px"}}>
                    <h4 style={{color:"white"}}class="card-title">India</h4>
                        
                        <a href="#" >LEARN MORE</a>
                    </div>
                </div>
            </div>  


        </div>
    </div> */}





            {/* <div class="container-fluid">

        <div class="row Partnership-Ecosystem">

            <div class="col-md-3">
                <div class="">
                    <div class="card-body">
                        <h5 class="card-title">Robust Partnership Ecosystem</h5>
                        <p class="card-text">Delivering value to clients through partnerships with leading technology
                            platforms, deep practitioner expertise and comprehensive partner certification programs..
                        </p>
                        <a  class="btn btn-primary Robust-Partnership-Ecosystem">LEARN MORE</a>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card">

                    <div class="card-body">
                        <img class="card-img-top" src="https://via.placeholder.com/150" alt="Card image cap"/>

                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card">

                    <div class="card-body">
                        <img class="card-img-top" src="https://via.placeholder.com/150" alt="Card image cap"/>

                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card">

                    <div class="card-body">
                        <img class="card-img-top" src="https://via.placeholder.com/150" alt="Card image cap"/>

                    </div>
                </div>
            </div>


        </div>
    </div> */}

            {/* <div class="container-fluid">

        <div class="row">

            <div class="col-md-6">
                <div class="">
                    <div class="card-body">
                        <h1 class="card-title">Truly Global, Authentically Diverse Team</h1>
                        <p class="card-text">Shanvatech’s Global Delivery capabilities are truly global with all major
                            talent regions, including India, Latin America, US and Canada, Europe and Southeast Asia.
                            Deeply established, local leadership teams deliver consistent client experiences spanning
                            Shanvatech’s authentically diverse global operations...</p>
                        <p class="card-text">Recognized as a Great Place to Work in eight countries, Shanvatech
                            consistently attracts and retains the best tech talent around the world. Its compelling
                            employee value proposition, combined with an award-winning company culture, translates into
                            the lowest employee attrition rate across the industry.</p>
                        <a href="#" class="Truly-Global">LEARN MORE</a>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="card">

                    <div class="card-body">
                        <img class="card-img-top" src="https://via.placeholder.com/150" alt="Card image cap"/>

                    </div>
                </div>
            </div>



        </div>
    </div> */}


            <div className="container-fluid why-shanvatech" style={{ backgroundImage: "linear-gradient(-15deg,rgb(226, 212, 245) 0%, rgb(255, 255, 255) 70%)", paddingTop: "100px" }}>

                <div className="row">

                    <div className="col-md-4 col-lg-2">
                        <div className="">
                            <div className="card-body">
                                <h3 className="card-title">Why Shanvatech?</h3>
                                <p className="card-text">Shanvatech is a trusted technology partner, driving digital transformation with specialized expertise, innovative solutions, and a commitment to excellence.</p>

                                {/* <a href="#" className="why-shanvatech-btn">LEARN MORE</a> */}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 col-lg-2">
                        <div className="card shanvatech-cards">

                            <div className="card-body">
                                <h5 className="card-title">Cutting-Edge Capabilities</h5>
                                <p className="card-text">Expertise in cloud, data, AI, and emerging technologies to power business growth.</p>

                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 col-lg-2">
                        <div className="card shanvatech-cards">

                            <div className="card-body">
                                <h5 className="card-title">Proven Client Success</h5>
                                <p className="card-text">Delivering high-impact solutions with a client-first approach</p>

                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 col-lg-2">
                        <div className="card shanvatech-cards">

                            <div className="card-body">
                                <h5 className="card-title">Scalable SolutionsScale</h5>
                                <p className="card-text">A growing team of skilled professionals providing tailored IT and workforce solutions</p>

                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 col-lg-2">
                        <div className="card shanvatech-cards">

                            <div className="card-body scroll-box">
                                <h5 className="card-title">Global Reach, Local Expertise</h5>
                                <p className="card-text">Expanding presence across Asia, Europe, and the Americas, with strong capabilities in India.</p>

                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 col-lg-2">
                        <div className="card shanvatech-cards">

                            <div className="card-body">
                                <h5 className="card-title">Top Talent in Technology & Hiring</h5>
                                <p className="card-text">Dedicated to sourcing and retaining the best talent, ensuring long-term success for businesses.</p>

                            </div>
                        </div>
                    </div>



                </div>
            </div>


            <ContactForm />



        </div>
    )
}

export default Home;